import { BasicDialogModal } from '@ingenico/react-ui/basic-dialog-modal';
import { CoreButton } from '@ingenico/react-ui/core-button';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { SimplifiedBlockDeviceModalProps } from './SimplifiedBlockDeviceModal.model';
import styles from './SimplifiedBlockDeviceModal.module.scss';
import { ALL_LNGS_NAMESPACES } from '@ingenico/util-i18n-config';

export function SimplifiedBlockDeviceModal({
  isOpen,
  isLoading,
  onBlockDevice,
  onCancel,
}: SimplifiedBlockDeviceModalProps): ReactNode {
  const { t } = useTranslation([ALL_LNGS_NAMESPACES.LOGICAL_DEVICE]);

  return (
    <BasicDialogModal
      actions={
        <div className={styles.modalActions}>
          <CoreButton disabled={isLoading} onClick={onCancel} variant="text">
            {t('button.cancel', { ns: ALL_LNGS_NAMESPACES.COMMON })}
          </CoreButton>
          <CoreButton
            loading={isLoading}
            onClick={() => {
              void onBlockDevice();
            }}
            variant="contained"
          >
            {t('button.blockDevice', { ns: ALL_LNGS_NAMESPACES.LOGICAL_DEVICE })}
          </CoreButton>
        </div>
      }
      customPaperClassName={styles.paperContainer}
      customActionsClassName={styles.customActionsClassName}
      isOpen={isOpen}
      onClose={onCancel}
      title={t('blockDeviceModal.confirmationTitle', { ns: ALL_LNGS_NAMESPACES.LOGICAL_DEVICE })}
      subTitle={t('blockDeviceModal.confirmationSubtitle', { ns: ALL_LNGS_NAMESPACES.LOGICAL_DEVICE })}
    />
  );
}
